import { render, staticRenderFns } from "./RequestBasicDataReport.vue?vue&type=template&id=1028ea9b&scoped=true"
import script from "./RequestBasicDataReport.vue?vue&type=script&lang=js"
export * from "./RequestBasicDataReport.vue?vue&type=script&lang=js"
import style0 from "./RequestBasicDataReport.vue?vue&type=style&index=0&id=1028ea9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028ea9b",
  null
  
)

export default component.exports